import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
// import { RequestOptions, URLSearchParams } from '@angular/http';
import { environment } from '../../../environments/environment';
import { PhoneList } from '../models';

@Injectable()
export class PhoneService {
  private apiUrl: string;
  phoneList: PhoneList;
  obs: any;

  constructor(private http: Http) {
    this.apiUrl = `${environment.apiUrl}`;
    this.initObs();
  }

  initObs() {
    this.obs = {
      phoneList: this.http.get(`${this.apiUrl}`)
      .map((res: Response) => res.json())
      .map((response) => {
        this.phoneList = new PhoneList(response);
        console.log(this.phoneList);
        // console.log('here');
        return this.phoneList;
      })
      .do(() => {
        // console.log(this.phoneList);
      })
      // .share()
      .publishReplay(1)
      .refCount()
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/services/phone.service.ts